import {
  Button,
  DialogTitle,
  DialogContent,
  FormControl,
  TextField,
  CircularProgress,
} from '@mui/material';
import React, { useState } from 'react';
import QrCodeIcon from '@mui/icons-material/QrCode';
import CustomDialog from '../../common/custom-dialog/custom-dialog';
import { nanoid } from 'nanoid';
import QRCode from 'qrcode';
import {
  Document,
  Page,
  StyleSheet,
  Text,
  View,
  Image,
  pdf,
} from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { format } from 'date-fns';
import { PreferredTemporaryPackagePackage } from '../../../utils/encoding';

const PAGE_WIDTH = 269.291;
const PAGE_HEIGHT = 127.559;

const styles = StyleSheet.create({
  page: {
    width: PAGE_WIDTH,
    height: PAGE_HEIGHT,
    padding: 0,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  qrCode: {
    width: 85,
    height: 85,
    marginRight: 2,
  },
  textContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  text: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#333',
  },
});

const generateQRCodeDataURL = async (text: string): Promise<string> => {
  try {
    return await QRCode.toDataURL(text);
  } catch (err) {
    console.error('QR generation failed', err);
    return '';
  }
};

const QRCodePDF = ({
  entries,
}: {
  entries: { id: string; qrDataUrl: string }[];
}) => (
  <Document>
    {entries.map(({ id, qrDataUrl }) => (
      <Page
        size={{ width: PAGE_WIDTH, height: PAGE_HEIGHT }}
        key={id}
        style={styles.page}
      >
        <Image src={qrDataUrl} style={styles.qrCode} />
        <View style={styles.textContainer}>
          <Text style={styles.text}>{id}</Text>
        </View>
      </Page>
    ))}
  </Document>
);

function PendingQRCodeGenerator() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [codeCount, setCodeCount] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  const handleGeneratePDF = async () => {
    setLoading(true);
    const dateStr = format(new Date(), 'yyMMdd');
    const basePrefix = nanoid(8);

    const ids = Array.from({ length: codeCount }, (_, i) => {
      const index = i + 1;
      return `${PreferredTemporaryPackagePackage}${dateStr}${basePrefix}-${index}`;
    });

    const entries = await Promise.all(
      ids.map(async (id) => ({
        id,
        qrDataUrl: await generateQRCodeDataURL(id),
      }))
    );

    const blob = await pdf(<QRCodePDF entries={entries} />).toBlob();
    saveAs(blob, `qr-codes-${dateStr}.pdf`);
    setLoading(false);
    setDialogOpen(false);
  };

  return (
    <>
      <Button variant="outlined" onClick={() => setDialogOpen(true)}>
        <QrCodeIcon /> Generate Pending QR Codes
      </Button>

      <CustomDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Pending QR Code Generator</DialogTitle>
        <br />
        <DialogContent>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleGeneratePDF();
            }}
          >
            <FormControl fullWidth>
              <TextField
                autoComplete="off"
                required
                value={codeCount}
                type="number"
                placeholder="Number of QR codes"
                label={'Number of QR Codes'}
                InputProps={{ inputProps: { min: 1, max: 1000 } }}
                onChange={(e) => setCodeCount(parseInt(e.target.value))}
              />
            </FormControl>

            <br />
            <br />
            <div style={{ width: '100%', textAlign: 'center' }}>
              {loading ? (
                <>
                  <CircularProgress /> Generating...
                </>
              ) : (
                <Button variant="contained" type="submit">
                  Print
                </Button>
              )}
            </div>
          </form>
        </DialogContent>
      </CustomDialog>
    </>
  );
}

export default PendingQRCodeGenerator;
